import { Col, ProgressBar, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Summary_LoadingBar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  const hitRange = item.scale.ranges.find((scale) => scale.isHit);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Conditional styles based on RGB color setting
  const nameStyle = rgbEnabled
    ? {
        fontSize: isSub ? "20px" : "22px", // Use original WrapUp sizes
        fontWeight: "600",
        lineHeight: "1.2",
        color: !isSub ? colors.dark : colors.primary,
      }
    : {};

  const scoreStyle = rgbEnabled
    ? {
        fontSize: "20px", // Use original WrapUp size
        fontWeight: "600",
        backgroundColor: colors.primary,
        color: "#ffffff",
        border: `1px solid ${colors.dark}`,
        borderRadius: "50%",
        padding: "0",
        width: "38px", // Original WrapUp size
        height: "38px", // Original WrapUp size
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }
    : {};

  // Create unique class name for this component instance to avoid conflicts
  const uniqueProgressBarClass = `progress-bar-${Math.random().toString(36).substr(2, 9)}`;

  const progressBarStyle = rgbEnabled
    ? {
        height: "20px",
        backgroundColor: colors.light,
        borderRadius: "0.375rem",
        overflow: "hidden",
      }
    : { height: "20px" };

  const progressBarInnerStyle = rgbEnabled
    ? {
        backgroundColor: colors.primary,
        border: `1px solid ${colors.dark}`,
        borderRadius: "0.375rem",
      }
    : {
        backgroundColor: isSub ? "#007aff" : "#00428a",
      };

  return (
    <Row className="mb-3 mx-0" style={{ height: "auto", padding: "2px 0" }}>
      <Col xs={3} className="align-content-center">
        <Row>
          <Col
            className={
              rgbEnabled
                ? "align-content-center"
                : "align-content-center " + (isSub ? "sub-scope-name-wrap-up" : "main-scope-name-wrap-up")
            }
            style={nameStyle}
          >
            {item.name}
          </Col>
          <Col xs="auto" style={{ display: "inline-block", float: "right" }}>
            <div
              className={rgbEnabled ? "" : !isSub ? "main-scope-score-wrap-up" : "sub-scope-score-wrap-up"}
              style={scoreStyle}
            >
              {elementScore}
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={9} className="align-content-center">
        <ProgressBar
          variant={rgbEnabled ? undefined : isSub ? "sub-scope" : "main-scope"}
          now={elementScore}
          label={`%${elementScore} ${hitRange?.text || ""}`}
          style={progressBarStyle}
          className={uniqueProgressBarClass}
        />
        {rgbEnabled && (
          <style jsx>{`
            .${uniqueProgressBarClass} .progress-bar {
              background-color: ${colors.primary} !important;
              border: 1px solid ${colors.dark} !important;
              border-radius: 0.375rem !important;
            }
          `}</style>
        )}
      </Col>
    </Row>
  );
}
